export const parseJSON = (string, fallbackValue, ...args) => {
  try {
    return JSON.parse.call(this, string, ...args)
  } catch (error) {
    console.error(error)
    return fallbackValue
  }
}
